import Vue from 'vue'
import type from './type'
import { Options } from '@/api/options'

let options

export default function (optionType) {
    return {
        namespaced: true,
        state: () => ({
            options: {},
            loaded: {},
            loader: {},
        }),
        getters: {
            [type.getters.OPTIONS]: (state) => {
                return state.options[optionType] || []
            },
        },
        mutations: {
            [type.mutations.OPTIONS]: (state, payload) => {
                Vue.set(state.options, optionType, payload || [])
                if (state.options[optionType]?.length) {
                    state.loaded[optionType] = true
                }
            },
            [type.mutations.LOADER]: (state, payload) => {
                state.loader[optionType] = payload || null
            },
            [type.mutations.INVALIDATE]: (state) => {
                const keys = Object.keys(state.loaded)
                for (let key of keys) {
                    state.loaded[key] = false
                }
            },
        },
        actions: {
            async [type.actions.LOAD]({ state, getters, commit }, payload) {
                if (state.loaded[optionType]) {
                    return getters[type.getters.OPTIONS]
                } else {
                    return new Promise((resolve, reject) => {
                        if (!options) options = new Options()
                        const fetchPromise =
                            state.loader[optionType] || options.getOptions(optionType, payload)

                        if (!state.loader[optionType]) {
                            commit(type.mutations.LOADER, fetchPromise)
                        }
                        fetchPromise
                            .then((data) => {
                                commit(type.mutations.OPTIONS, data)
                                resolve(data)

                                commit(type.mutations.LOADER, null)
                            })
                            .catch(() => {
                                reject()
                            })
                    })
                }
            },
            [type.actions.REFRESH]({ commit }) {
                commit(type.mutations.INVALIDATE)
            },
        },
    }
}
